<template>
  <el-dialog
    :title="title"
    :visible.sync="showDialog"
    width="50rem"
    :before-close="clearDialog"
    class="dialog"
    top="5vh"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    append-to-body
    z-index="1000"
  >
    <div class="material-dialog">
      <el-form
        ref="materielForm"
        size="small"
        style="width: 80%;"
        label-width="120px"
        :model="material"
        :rules="formRules"
        label-suffix="："
      >
        <el-form-item label="品目编码" prop="materielCode">
          <el-input
            v-model.trim="material.materielCode"
            placeholder="请输入品目编码"
            maxlength="25"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="品目名称" prop="materielName">
          <el-input
            v-model.trim="material.materielName"
            placeholder="请输入品目名称"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="数量" prop="materielNum">
          <el-input-number
            v-model="material.materielNum"
            class="left-input-number"
            :min="0"
            :max="9999999999"
            :precision="2"
            placeholder="请输入数量"
            :controls="false"
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="品目单位" prop="unitType">
          <el-select
            v-model="material.unitType"
            style="width: 100%"
            filterable
            remote
            allow-create
            default-first-option
            placeholder="请输入单位，示例：台、个、千米"
            :remote-method="getUnitOptions"
          >
            <el-option
              v-for="item in unitOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="参数型号" prop="materielModel">
          <el-input
            v-model.trim="material.materielModel"
            placeholder="请输入参数型号"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="品牌/制造商" prop="materielBrand">
          <el-input
            v-model.trim="material.materielBrand"
            placeholder="请输入品牌/制造商"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item
          :label="isWuling && !requireTax ? '预算不含税单价' : '预算单价'"
          prop="budgetUnitPrice"
          :label-width="isWuling && !requireTax ? '140px' : '120px'"
        >
          <el-input-number
            v-model="material.budgetUnitPrice"
            class="left-input-number"
            placeholder="请输入预算单价"
            :min="0"
            :max="99999999999"
            :precision="2"
            :controls="false"
            style="width: 200px"
          />
          <span class="m-l-10">{{ isDollar ? '美元' : '元' }}</span>
          <money-in-cn v-if="!isDollar" :money="material.budgetUnitPrice" />
        </el-form-item>
        <el-form-item
          :label="isWuling && !requireTax ? '预算不含税总价' : '总价'"
          :label-width="isWuling && !requireTax ? '140px' : '120px'"
        >
          <el-input-number
            :value="totalPrice"
            class="left-input-number"
            placeholder="请输入总价"
            :controls="false"
            disabled
            style="width: 200px"
          />
          <span class="m-l-10">{{ isDollar ? '美元' : '元' }}</span>
          <money-in-cn v-if="!isDollar" :money="totalPrice" />
        </el-form-item>
        <el-form-item label="交货地点" prop="deliveryAddress">
          <el-input
            v-model.trim="material.deliveryAddress"
            placeholder="请输入交货地点"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="交货时间" prop="deliveryDay">
          <el-input-number
            v-model.trim="material.deliveryDay"
            placeholder="请输入交货时间"
            class="left-input-number"
            :controls="false"
            :min="0"
            :precision="0"
            style="width: 200px"
          />
          <span class="m-l-10">天</span>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model.trim="material.remarks"
            type="textarea"
            placeholder="请输入备注"
            :autosize="{ minRows: 11 }"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="附件上传">
          <upload
            ref="uploadFile"
            :file-id-before.sync="material.attachmentFileIds"
            :props-data="{
              limit: 1,
              multiple: true,
              bizType: bizType,
              attachmentType: attachmentType,
              uploadMode: 'fileId'
            }"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button :loading="loading" size="medium" @click="clearDialog">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        size="medium"
        @click="handleConfirm"
      >
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload'
import MoneyInCn from '@/components/common/MoneyInCn'
// 工具方法
import { cloneDeep } from 'lodash'
// 数据字典
import { unitOptions } from '@/dictionary/project/common'
import { isArray } from '@/utils/type-check'

export default {
  name: 'AddOrEditMaterialInfoDialog',

  components: { Upload, MoneyInCn },

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    // 是否是五菱发布的项目
    isWuling: {
      type: Boolean,
      default: false
    },

    showDialog: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    // 品目信息
    materialInfo: {
      type: Object,
      default: () => {}
    },

    // 上传组件需要的定义参数
    uploadParams: {
      type: Object,
      default: () => {
        return {
          bidType: '',
          attachmentType: ''
        }
      }
    },

    // 是否美元报价
    isDollar: {
      type: Boolean,
      default: false
    },

    // 报价是否含税
    requireTax: {
      type: Boolean,
      default: false
    }
  },

  data() {
    // 校验函数
    const checkUnitPrice = (rule, value, callback) => {
      if (value < 0) {
        callback(new Error('品目单价不能为负数'))
      } else {
        callback()
      }
    }

    return {
      loading: false,

      // 品目表单
      material: {
        materielCode: '', // 品目编码
        materielName: '', // 品目名称
        materielNum: undefined, // 数量
        materielModel: '', // 参数型号
        budgetUnitPrice: undefined, // 预算单价
        // totalPrice: 0, // 总价，总价禁止填写，根据数量和预算单价自动计算
        unitType: '', // 单位
        remarks: '', // 备注
        attachmentFileIds: [], // 附件组id
        materielBrand: '', // 品牌/制造商
        deliveryAddress: '', // 交货地点
        deliveryDay: undefined // 交货时间
      },

      // 表单校验规则
      formRules: {
        materielCode: [
          {
            pattern: /^[0-9a-zA-Z]*$/,
            message: '品目编码只接受字母或数字',
            trigger: 'blur'
          }
        ],
        materielName: [
          {
            required: true,
            message: '请输入品目名称',
            trigger: 'blur'
          }
        ],
        materielNum: [
          {
            required: true,
            message: '请输入品目数量',
            trigger: 'blur'
          },
          {
            pattern: /^(([1-9]\d*)|0)(\.\d{0,2})?$/,
            message: '请输入仅包含小数点两位的有效数字',
            trigger: 'blur'
          }
        ],
        budgetUnitPrice: [
          {
            required: true,
            message: '请输入品目单价',
            trigger: 'blur'
          },
          {
            pattern: /^(([1-9]\d*)|0)(\.\d{0,2})?$/,
            message: '请输入仅包含小数点两位的有效数字',
            trigger: 'blur'
          },
          {
            validator: checkUnitPrice,
            trigger: 'blur'
          }
        ],
        unitType: [
          {
            required: true,
            message: '请输入单位',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (value.length > 10) {
                callback(new Error('单位长度不能超过10个字符'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },

      unitOptions: [] // 品目单位
    }
  },

  computed: {
    //  总价
    totalPrice() {
      let price = 0
      if (this.material.materielNum) {
        price = (
          (this.material.materielNum *
            100 *
            (this.material.budgetUnitPrice * 100)) /
          10000
        ).toFixed(2)
      }
      return isNaN(price) ? 0 : price
    },

    bizType() {
      return this.uploadParams.bizType
    },

    attachmentType() {
      return this.uploadParams.attachmentType
    }
  },

  created() {
    if (JSON.stringify(this.materialInfo) !== '{}') {
      this.material.attachmentFileIds = this.material.attachmentFileIds?.length
        ? this.material.attachmentFileIds.split(',')
        : []
      this.material = Object.assign({}, this.materialInfo)
    }
  },

  methods: {
    // 关闭对话框时，执行的函数
    clearDialog() {
      if (this.$refs.uploadFile && !this.$refs.uploadFile.uploadComplete()) {
        return false
      }

      // 对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
      this.$refs.materielForm.resetFields()
      this.$emit('change', !this.showDialog)
    },

    // 模拟远程获取单位
    getUnitOptions(query) {
      query = query.trim()
      if (!query) {
        this.unitOptions = []
        return
      }

      this.unitOptions = unitOptions.filter(unit => {
        return unit.label.indexOf(query) > -1
      })
    },

    // 点击确定
    handleConfirm() {
      if (this.$refs.uploadFile && !this.$refs.uploadFile.uploadComplete()) {
        return false
      }
      this.$refs.materielForm.validate().then(valid => {
        if (valid) {
          this.material.totalPrice = this.totalPrice
          if (!isArray(this.material.attachmentFileIds)) {
            this.material.attachmentFileIds = this.material.attachmentFileIds?.length
              ? this.material.attachmentFileIds.split(',')
              : []
          }
          const tempData = cloneDeep(this.material)
          this.$emit('material', tempData)
          this.clearDialog()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.dialog {
  ::v-deep .el-dialog--center .el-dialog__body {
    padding-bottom: 0;
  }

  ::v-deep .el-input-number {
    &.left-input-number {
      .el-input__inner {
        text-align: left;
      }
      input::placeholder {
        text-align: left !important;
      }
    }
  }
}
</style>
